import { OutputData } from '@editorjs/editorjs'

export const guardOutputData = (value: unknown): value is OutputData => {
    return (
        typeof value === 'object' &&
        value !== null &&
        'version' in value &&
        'time' in value &&
        'blocks' in value &&
        Array.isArray(value.blocks)
    )
}

export const guardHabitBatchConfig = (
    value: unknown
): value is { enabled: boolean; size: number } =>
    typeof value === 'object' &&
    value !== null &&
    'enabled' in value &&
    'size' in value &&
    typeof value.enabled === 'boolean' &&
    typeof value.size === 'number'
